import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VSnackbar,{attrs:{"top":"","timeout":_vm.snackbar.timeout,"multi-line":true,"color":_vm.snackbar.color},model:{value:(_vm.snackbar.visible),callback:function ($$v) {_vm.$set(_vm.snackbar, "visible", $$v)},expression:"snackbar.visible"}},[_c('span',{staticClass:"snack"},[_vm._v(" "+_vm._s(_vm.snackbar.text))]),_c(VBtn,{attrs:{"text":"","dark":"","right":""},on:{"click":_vm.closeNotification}},[_vm._v(_vm._s(_vm.$t("button.close")))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }